import { React, useEffect, useState } from "react";
import { connect } from "react-redux";
// @material-ui/core components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Pagination from "@material-ui/lab/Pagination";

// core componentssrc
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import InformationDisseminationCard from "../Card/InformationDisseminationCard";
import { ArrayUtils } from "utils/array_utils";
import CardsListBackdrop from "components/Backdrops/CardsListBackdrop";
import { getSocialMediaLinksAction } from "redux/actions/socialMediaAction.js";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function ResultSection(props) {
  const classes = useStylesGeneric();
  const [informationList, setInformationList] = useState([]);

  useEffect(() => {
    props.getSocialMediaLinks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!ArrayUtils.NullOrEmpty(props.informationDisseminationState.result)) {
      setInformationList(props.informationDisseminationState.result.data);
    } else {
      setInformationList([]);
    }
  }, [props.informationDisseminationState.result]);

  return (
    <>
      {informationList !== undefined && informationList?.length > 0 ? (
        <Grid container style={{ position: "relative" }}>
          {informationList?.map((info, key) => (
            <Grid key={key} item xs={12} md={6} lg={4} xl={3}>
              <InformationDisseminationCard
                alternateKey={info.alternateKey}
                informationDisseminationTypeDescription={info.informationDisseminationTypeDescription}
                informationDisseminationTypeKeyValue={info.informationDisseminationTypeKeyValue}
                isPublic={info.isPublic}
                title={info.title}
                description={info.description}
                published={info.published}
                publishedOn={info.publishedOn}
                photo={info.photo}
              />
            </Grid>
          ))}
          <CardsListBackdrop open={props.informationDisseminationState.filteredInformation_loading} />
        </Grid>
      ) : (
        <Box classes={{ root: classes.noResultsInfo }}>
          Não foram encontrados resultados para esta pesquisa.
        </Box>
      )}
      <Pagination
        className={classes.alignPagination}
        count={props.informationDisseminationState?.total_pages}
        page={props.page}
        onChange={props.handleChangePage}
        color="primary"
      ></Pagination>
    </>
  );
}
const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getSocialMediaLinks: () => dispatch(getSocialMediaLinksAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResultSection);
